import { CommonModule } from '@angular/common';
import { Component, Input, Type, ViewEncapsulation } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import {
  UiStepperActionContext,
  UiStepperState,
  UiStepperStep,
  UiStepperSubStep,
} from './stepper.types';
import { StepperIconComponent } from './stepper-icon.component';

@Component({
  selector: 'app-stepper-sub-step',
  standalone: true,
  imports: [CommonModule, StepperIconComponent, NgbTooltip],
  templateUrl: './stepper-sub-step.component.html',
  styleUrl: './stepper-sub-step.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class StepperSubStepComponent {
  @Input({ required: true }) step!: UiStepperStep;

  @Input({ required: true }) subStep!: UiStepperSubStep;

  @Input({ required: true }) stepIndex = 0;

  @Input({ required: true }) subStepIndex = 0;

  @Input() showConnector = false;

  get state(): UiStepperState {
    return this.subStep.state ?? 'pending';
  }

  get showAction(): boolean {
    return this.hasCustomAction || this.hasButtonAction;
  }

  get hasCustomAction(): boolean {
    return Boolean(this.subStep.actionComponent?.component);
  }

  get hasButtonAction(): boolean {
    return !this.hasCustomAction && Boolean(this.subStep.action);
  }

  get customActionComponent(): Type<unknown> | null {
    return this.subStep.actionComponent?.component ?? null;
  }

  get customActionInputs(): Record<string, unknown> {
    return this.subStep.actionComponent?.inputs ?? {};
  }

  get isOptional(): boolean {
    return this.subStep.required === false;
  }

  get actionAriaLabel(): string {
    return (
      this.subStep.action?.ariaLabel ??
      this.subStep.action?.label ??
      `${this.subStep.label} action`
    );
  }

  get actionTooltip(): string | null {
    return this.subStep.action?.tooltip ?? null;
  }

  get actionColor(): string {
    if (this.subStep.action?.disabled) {
      return 'var(--light-gray-500)';
    }

    return this.subStep.action?.color ?? 'var(--brand-600)';
  }

  handleActionClick(): void {
    if (!this.subStep.action?.onClick || this.subStep.action.disabled) {
      return;
    }

    const context: UiStepperActionContext = {
      step: this.step,
      stepIndex: this.stepIndex,
      subStep: this.subStep,
      subStepIndex: this.subStepIndex,
    };

    this.subStep.action.onClick(context);
  }
}
